import { render, staticRenderFns } from "./PrintInfoBox.vue?vue&type=template&id=42ef6f31&scoped=true&"
import script from "./PrintInfoBox.vue?vue&type=script&lang=js&"
export * from "./PrintInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./PrintInfoBox.vue?vue&type=style&index=0&id=42ef6f31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ef6f31",
  null
  
)

/* custom blocks */
import block0 from "./PrintInfoBox.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42ef6f31')) {
      api.createRecord('42ef6f31', component.options)
    } else {
      api.reload('42ef6f31', component.options)
    }
    module.hot.accept("./PrintInfoBox.vue?vue&type=template&id=42ef6f31&scoped=true&", function () {
      api.rerender('42ef6f31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/print/report/shared/PrintInfoBox.vue"
export default component.exports